import React from "react";
import { useNavigation } from "@origin-digital/navigation-client-sdk";
import styled from "styled-components";
import { NavLink } from "../NavLink";

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${(p) => p.theme.space.large}px;
  @media (min-width: ${(p) => p.theme.breakpoints.values.xl}px) {
    gap: ${(p) => p.theme.space.xlarge}px;
  }
`;

export const DesktopNav = () => {
  const { data } = useNavigation();
  const navData = data?.children;

  return (
    <Container>
      {navData?.map((navLink) => (
        <NavLink key={navLink.name} linkConfig={navLink} headlineLink />
      ))}
    </Container>
  );
};
